import axios from 'axios';
import SaveTokenInterceptor from '../interceptors/saveToken';

const Services = {
    initAPI: function (baseURL) {
        const API = axios.create({ baseURL, withCredentials: true });
        SaveTokenInterceptor(API);
        return API;
    },
};

export default Services;
